import React, { useState } from 'react';
import { Flex, Button, Typography, Row, Col } from 'antd';
import { PaperClipOutlined, PlusOutlined } from '@ant-design/icons';
import { AuditsCreation, AuditCard, InsightCard, AuditDetails } from './components';
import { useToggle } from 'hooks/useToggle';

export const Audits = () => {
  const [openNewAudit, toggleNewAudit] = useToggle(false);
  const [openAuditDetails, toggleAuditDetails] = useToggle(false);
  const [currentAudit, setCurrentAudit] = useState(null);

  const auditsMock = [
    {
      id: 0,
      title: 'Q1 2024 Family Retention Intent Survey',
      school: 'Test School',
      author: 'Admin',
      date: '17/7/2025',
      type: 'Retention',
      status: 'Active',
      people: 8,
      progress: 0,
    },
  ];

  const handleAuditClick = (audit) => {
    setCurrentAudit(audit);
    toggleAuditDetails();
  };

  return (
    <div>
      <Flex align="center" justify="space-between">
        <div>
          <Typography.Title level={2}>Family Retention & Experience Audits</Typography.Title>
          <Typography.Paragraph>
            Create and manage family retention audits to improve satisfaction and retention
          </Typography.Paragraph>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={toggleNewAudit}>
          New Audit
        </Button>
      </Flex>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <InsightCard title="Total Audits" amount={0} label="All time" Icon={PaperClipOutlined} />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <InsightCard title="Total Responses" amount={13} label="Across all audits" Icon={PaperClipOutlined} />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <InsightCard title="Active Audits" amount={2} label="Currently running" Icon={PaperClipOutlined} />
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: '1.5rem' }}>
        {auditsMock.map((audit) => (
          <Col key={audit.id} xs={24} sm={12} md={8}>
            <AuditCard
              onClick={() => handleAuditClick(audit)}
              title={audit.title}
              school={audit.school}
              description="Understanding family satisfaction and likelihood to return next year"
              by={audit.author}
              status={audit.status}
              people={audit.people}
              progress={audit.progress}
              date={audit.date}
            />
          </Col>
        ))}
      </Row>
      <AuditsCreation isOpen={openNewAudit} onClose={toggleNewAudit} />
      <AuditDetails isOpen={openAuditDetails} onClose={toggleAuditDetails} audit={currentAudit} />
    </div>
  );
};
